// removed by extract-text-webpack-plugin
module.exports = {"container":"magazines_1i1i7","group":"magazines_3JaDX","btn":"magazines_1eHvv","icon":"magazines_1GDpg","isActive":"magazines_xrLGm","dropdown":"magazines_licLF","animation__dropdown":"magazines_1-2gh","backdrop":"magazines_2W4kw","animation__backdrop":"magazines_3usW8"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/Dashboard/components/MagazineCreateNewButton/styles.scss
// module id = 1048
// module chunks = 1